import { setColumnWidth } from "../../utils";
import * as XLSX from 'xlsx-js-style';
import { BudgetExportPreparer } from "./budget-export-preparer";
import { BudgetModelFormGroup } from "../../../models/budget-model/pojo/bm-form";


export class BudgetModelTemplate {
  export(exportExcelData: BudgetModelFormGroup, fileName: string): void {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(exportExcelData);
    XLSX.utils.book_append_sheet(book, sheet);
    XLSX.writeFile(book, fileName);
  }

  private getSheet(budgetForm: BudgetModelFormGroup): XLSX.WorkSheet {
    const preparer = new BudgetExportPreparer();
    const preparedData = preparer.getPreparedData(budgetForm);
    let sheet = XLSX.utils.aoa_to_sheet(preparedData);
    let updatedHeaders = preparer.getHeadersWithOutTotal();
    updatedHeaders = preparer.getHeadersForLogic();
    sheet = this.setHeadersLen(updatedHeaders, sheet);
    return sheet;
  }

  private prepareEmptyIndexes(headers: string[]): number[] {
    const emptyIndexes: number[] = [];
    headers.forEach((header, index) => {
      if (header === null) {
        emptyIndexes.push(index);
      }
    });
    return emptyIndexes;
  }

  private prepareNotEmptyIndexes(headers: string[]): number[] {
    const notEmptyIndexes: number[] = [];
    headers.forEach((header, index) => {
      if (header !== null && index) {
        notEmptyIndexes.push(index);
      }
    });
    return notEmptyIndexes;
  }

  private setHeadersLen(headers: string[], sheet: XLSX.WorkSheet): XLSX.WorkSheet {
    const indexOfSpace = this.prepareEmptyIndexes(headers);
    const headerLen = headers.length;
    const longColumns = [0];
    const totalColumns = [headerLen - 2, headerLen - 1];
    longColumns.forEach((columnIndex) => setColumnWidth(sheet, columnIndex, 25));
    const notEmptyIndexes = this.prepareNotEmptyIndexes(headers);
    notEmptyIndexes.forEach((index) => setColumnWidth(sheet, index, 13));
    indexOfSpace.forEach((index) => setColumnWidth(sheet, index, 1.5));
    totalColumns.forEach((columnIndex) => setColumnWidth(sheet, columnIndex, 16));
    return sheet;
  }
}
